import { CircularProgress } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import * as React from "react";
import { useIntl } from "react-intl";
import { GetTranslation } from "../../../../translations/GetTranslation";
import { useSignUpContext } from "../../CertificationDataWizardContext/CertificationDataWizardContext";
import { getSteps } from "../../StartCertificationWizard";
import StartCertificationSteps from "../../CertificationDataWizardContext/StartCertificationSteps";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    stepper: {
      padding: "0 0 40px 0",
      marginBottom: 20,
    },
    buttonContainer: {
      marginTop: 40,
      display: "flex",
      justifyContent: "center",
    },
    button: {
      marginRight: theme.spacing(1),
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  })
);

type ControlButtonsProps = {
  onNextClick?: () => void;
  onPreviousClick?: () => void;
  backDisabled?: boolean;
  nextDisabled?: boolean;
  isLoading?: boolean;
};

export const ControlButtons: React.FC<ControlButtonsProps> = ({
  onNextClick,
  onPreviousClick,
  backDisabled,
  nextDisabled,
  isLoading,
}) => {
  const classes = useStyles();
  const { activeStep, handlePrevStep } = useSignUpContext();
  const intl = useIntl();
  const steps = getSteps(intl);

  return (
    <div className={classes.buttonContainer}>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <>
          <Button
            disabled={activeStep === StartCertificationSteps.PersonalDataStep || backDisabled}
            onClick={onPreviousClick ?? handlePrevStep}
            className={classes.button}
          >
            {GetTranslation(intl, "startCertification.button.back")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            type={onNextClick ? undefined : "submit"}
            className={classes.button}
            onClick={onNextClick}
            disabled={nextDisabled !== undefined && nextDisabled}
          >
            {activeStep === steps.length - 1
              ? GetTranslation(intl, "startCertification.button.finish")
              : GetTranslation(intl, "startCertification.button.next")}
          </Button>
        </>
      )}
    </div>
  );
};
